import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  items: {},
});

export function merge(state, item) {
  const arr = Array.isArray(item) ? item : [item];
  return state
    .mergeIn(['items'], fromJS(arr.reduce((obj, i) => ({ ...obj, [i.id]: i }), {})));
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'RECIPE_SET':
      return merge(state, action.payload);

    case 'RECIPE_REMOVE':
      return state.removeIn(['items', action.payload]);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/recipe.js